// src/utils/phoneUtils.js
const supportedCountries = [
  { code: '+55', nationalLengths: [10, 11] },
  { code: '+54', nationalLengths: [10, 11] },
];

export const getPhoneDigits = (phone) => String(phone || '').replace(/\D/g, '');

export const formatBrazilPhone = (phone) => {
  const digits = getPhoneDigits(phone).substring(0, 11);

  if (!digits) {
    return '';
  }

  if (digits.length <= 2) {
    return `(${digits}`;
  }

  const ddd = digits.substring(0, 2);
  const number = digits.substring(2);
  const firstGroupLength = digits.length === 11 ? 5 : 4;

  if (number.length <= firstGroupLength) {
    return `(${ddd}) ${number}`;
  }

  return `(${ddd}) ${number.substring(0, firstGroupLength)}-${number.substring(firstGroupLength)}`;
};

export const formatArgentinaMobilePhone = (phone) => {
  const digits = getPhoneDigits(phone).substring(0, 11);

  if (digits.length <= 1) {
    return digits;
  }

  const mobilePrefix = digits.substring(0, 1);
  const nationalNumber = digits.substring(1);

  if (nationalNumber.length <= 4) {
    return `${mobilePrefix} ${nationalNumber}`;
  }

  if (nationalNumber.length <= 6) {
    return `${mobilePrefix} ${nationalNumber.substring(0, 4)} ${nationalNumber.substring(4)}`;
  }

  return `${mobilePrefix} ${nationalNumber.substring(0, 4)} ${nationalNumber.substring(4, 6)}-${nationalNumber.substring(6)}`;
};

export const formatPhoneNumber = (countryCode, phone) => {
  if (countryCode === '+55') {
    return formatBrazilPhone(phone);
  }

  if (countryCode === '+54') {
    return formatArgentinaMobilePhone(phone);
  }

  return phone;
};

export const isValidPhoneNumber = (countryCode, phone) => {
  const digits = getPhoneDigits(phone);

  if (countryCode === '+55') {
    return digits.length === 10 || digits.length === 11;
  }

  if (countryCode === '+54') {
    return digits.length === 11 && digits.startsWith('9');
  }

  return false;
};

export const splitInternationalPhone = (phone) => {
  const digits = getPhoneDigits(phone);
  const country = supportedCountries.find(({ code, nationalLengths }) => {
    const countryDigits = code.substring(1);
    const nationalLength = digits.length - countryDigits.length;

    return digits.startsWith(countryDigits) && nationalLengths.includes(nationalLength);
  });

  if (!country) {
    return null;
  }

  return {
    countryCode: country.code,
    phoneNumber: digits.substring(country.code.length - 1),
  };
};

export const saveInternationalPhone = (phone, storage = localStorage) => {
  const phoneData = splitInternationalPhone(phone);

  if (!phoneData) {
    return false;
  }

  storage.setItem('telefoneClienteInput', phoneData.phoneNumber);
  storage.setItem('countryCodeInput', phoneData.countryCode);
  return true;
};
